import "core-js/modules/es.date.to-string.js";
import { convertDateHoursInMilliseconds, convertDateToTargetTimeZoneDate, isWeekendFromDate } from "@faire/help-center-utils/lib/dateInTimeZone";
import { getSettingPhoneWorkingHours } from "@faire/help-center-utils/settings/getSettingPhoneWorkingHours";
export var isPhoneInBusinessHours = function isPhoneInBusinessHours() {
  var _getSettingPhoneWorki = getSettingPhoneWorkingHours(),
    start_at = _getSettingPhoneWorki.start_at,
    end_at = _getSettingPhoneWorki.end_at,
    timezone = _getSettingPhoneWorki.timezone;
  if (!start_at || !end_at) {
    return false;
  }
  var now = new Date();
  var targetDate = convertDateToTargetTimeZoneDate(now, timezone !== null && timezone !== void 0 ? timezone : "America/New_York");
  if (isWeekendFromDate(targetDate)) {
    return false;
  }
  var hoursInMilliseconds = convertDateHoursInMilliseconds(targetDate);
  return start_at <= hoursInMilliseconds && hoursInMilliseconds < end_at;
};